import { render, staticRenderFns } from "./AdminResults.vue?vue&type=template&id=1e7bbd76&scoped=true"
import script from "./AdminResults.vue?vue&type=script&lang=js"
export * from "./AdminResults.vue?vue&type=script&lang=js"
import style0 from "./AdminResults.vue?vue&type=style&index=0&id=1e7bbd76&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7bbd76",
  null
  
)

export default component.exports